import { FormsApi } from '../../generated/new';

const formsApi = new FormsApi();

export default formsApi;
